<template>
  <div class="select_info">
    <div class="info_nav">
      <navbar
        title="选择设备"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <van-row class="box">
      <van-col span="24" v-if="navList.length != 0">
        <img
          class="item"
          v-for="(item, index) in navList"
          :key="index"
          :src="item.image"
          @click="select(item)"
        />
      </van-col>
      <van-col span="24" v-if="navList.length == 0">
        <img class="icon" src="@/assets/accountAgent/my/no_info.png" />
        <p class="tip">暂无数据</p>
      </van-col>
    </van-row>
    <van-dialog v-model="showPersonal" :show-cancel-button="false" width="300" :showConfirmButton="false">
      <div class="per-title">实名认证提示</div>
      <div class="per-content">
        为保护您的账号安全，并确认用户账号为本人持有，请先进行实名认证。
      </div>
      <div class="per-box">
        <span @click="showPersonal = false">取消</span>
        <span @click="goPersonal">认证</span>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import navbar from "../accountAgent/components/nav-bar.vue";
import btn from "../accountAgent/components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      navList: [],
      showPersonal: false
    };
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.getInfo();
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getInfo() {
      this.$api.get("/ongoods/index/equipment/nav/list").then((res) => {
        res.list.forEach((item) => {
          if (item.status == 1) {
            this.navList.push(item);
          }
        });
      });
    },
    select(item) {
      let _this = this;
      this.$api.get("member/member/member/auth/detail").then((res) => {
        if(res){
            if(res.status == 2){//已实名认证
              _this.$router.push({
                path: "/equipment/rule",
                query: {
                  goodsId: item.goods_id,
                  agreementId: item.agreement_id,
                },
              });
            }else{
                _this.showPersonal = true;
            }
        }
      });
    },
    goPersonal(){
      this.showPersonal = false;
      try{
        this.params("", "", "personal");
      }catch(err){
        this.$dialog.alert({
          message: "为了功能的正常使用，请自行去应用商城升级到最新版本，谢谢您的配合！",
          confirmButtonText: "确定",
          className: "dialog",
        }).then(() => {});
      }
    }
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.select_info {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .info_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .box {
    padding: 10.8rem 1.5rem 0;
    box-sizing: border-box;
    height: 100%;
    background-size: 100%;
    position: relative;
    text-align: center;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .item {
      width: 100%;
      min-height: 11.5rem;
      margin-bottom: 1.5rem;
      display: block;
    }

    .icon {
      width: 21.3rem;
      margin-top: 20rem;
    }

    .tip {
      color: #999;
      font-size: 1.5rem;
      line-height: 6rem;
    }
  }
}
.per-title{
  color: #333333;
  text-align: center;
  font-size: 1.8rem;
  font-weight: 600;
  padding: 2.1rem 0 1.5rem 0;
}
.per-content{
  font-size: 1.5rem;
  color: #333333;
  padding: 0 1.7rem;
}
.per-box{
  padding: 3rem 0 2rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  &>span{
    width: 9.6rem;
    height: 3.4rem;
    display: inline-flex;
    border-radius: 1.8rem;
    justify-content: center;
    line-height: 3.4rem;
    font-size: 1.6rem;
  }
  &>span:nth-of-type(1){
    border: 1px solid #E5E5E5;
    color: #666666;
    box-sizing: border-box;
  }
  &>span:nth-of-type(2){
    background: #FF5F2E;
    color: #fff;
    margin-left: 2.6rem;
  }
}
</style>


